import paymentMode from '../../../services/purchase/paymentMode'

export default {
    namespaced: true,
    state: {
        list: [],
        loading: false
    },
    getters: {
        list: state => state.list,
        loading: state => state.loading
    },
    mutations: {
        setLoading: (state, payload) => state.loading = payload,
        setList: (state, payload) => state.list = payload
    },
    actions: {
        index(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit("setLoading", true);
                paymentMode.index(payload).then(response => {
                    context.commit("setList", response.data);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }).finally(() => {
                    context.commit("setLoading", false);
                });
            });
        },
        find(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit("setLoading", true);
                paymentMode.find(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }).finally(() => {
                    context.commit("setLoading", false);
                });
            });
        },
        createAccount(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit("setLoading", true);
                paymentMode.createAccount(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }).finally(() => {
                    context.commit("setLoading", false);
                });
            });
        },
        removeAccount(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit("setLoading", true);
                paymentMode.removeAccount(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }).finally(() => {
                    context.commit("setLoading", false);
                });
            });
        }
    }
}